module.exports = __webpack_public_path__ + "img/Group 873.85519947.png";